import { jwtDecode } from 'jwt-decode';

export function fixLocalDate(date) {
    const d = new Date(date);
    d.setHours(12, 0, 0, 0);
    return d;
  }
  
export function generateRangeDays(start, end) {
    const days = [];
    let current = new Date(start);
    while (current <= end) {
      const dow = current.getDay();
      if (dow !== 0 && dow !== 6) {
        days.push(fixLocalDate(current));
      }
      current.setDate(current.getDate() + 1);
    }
    return days;
}
  
export function generateCyclicDays(first, second) {
    const days = [];
    const dow = first.getDay();
    let start = first < second ? first : second;
    let end = first < second ? second : first;
  
    const cursor = new Date(start);
    while (cursor <= end) {
      if (cursor.getDay() === dow) {
        days.push(fixLocalDate(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return days;
}
  
export function getClosestWorkingDay(date = new Date()) {
    const result = new Date(date);
    const hour = result.getHours();
    if (hour >= 19) result.setDate(result.getDate() + 1);
  
    while (result.getDay() === 0 || result.getDay() === 6) {
      result.setDate(result.getDate() + 1);
    }
  
    return fixLocalDate(result);
  }

export function isAffectingNextWorkingDay(selectedDates) {
  const now = new Date();
  const hour = now.getHours();
  let target = new Date(now);
  if (hour >= 19) {
    target.setDate(target.getDate() + 1);
  }

  // Szukaj najbliższego dnia roboczego
  while (target.getDay() === 0 || target.getDay() === 6) {
    target.setDate(target.getDate() + 1);
  }

  const targetStr = target.toISOString().split('T')[0];
  return selectedDates.some(d => d.toISOString().split('T')[0] === targetStr);
}

export const normalizeDateToStr = d =>
  new Date(d).toISOString().split("T")[0];


export function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    if (!decoded.exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (err) {
    return true; // token nieprawidłowy = traktujemy jako wygasły
  }
}